module.exports = __webpack_public_path__ + "img/5.f98b575b.jpg";